import { useColorScheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import { AuthProvider } from "./AuthProvider";
import { LeftMenuProvider } from "./LeftMenuProvider";
import { TopMenuProvider } from "./TopMenuProvider";
// import { ProfileProvider, useProfile } from './Profile';

export const AppProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { mode } = useColorScheme();

  if (!mode) {
    return null;
  }

  return (
    <AuthProvider>
      {/* <ProfileProvider> */}
      <TopMenuProvider>
        <LeftMenuProvider>{children}</LeftMenuProvider>
      </TopMenuProvider>
      {/* </ProfileProvider> */}
    </AuthProvider>
  );
};
